(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vehicle-selector-scroll"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var sections = document.querySelectorAll('.vs-scroll__track-wrapper');
    sections.forEach(function (wrapper) {
      var track = wrapper.querySelector('.vs-scroll__track');
      var prevBtn = wrapper.querySelector('.vs-scroll__arrow--prev');
      var nextBtn = wrapper.querySelector('.vs-scroll__arrow--next');
      var dotsContainer = wrapper.querySelector('[id^="vs-scroll-dots-"]');

      if (!track) return;

      var cards = track.querySelectorAll('.vs-scroll__card');
      if (cards.length === 0) return;

      function getScrollAmount() {
        var card = cards[0];
        var gap = parseFloat(getComputedStyle(track).gap) || 0;
        return card.offsetWidth + gap;
      }

      function updateArrows() {
        if (!prevBtn || !nextBtn) return;
        var scrollLeft = Math.round(track.scrollLeft);
        var maxScroll = track.scrollWidth - track.clientWidth;
        prevBtn.disabled = scrollLeft <= 1;
        nextBtn.disabled = scrollLeft >= maxScroll - 1;
      }

      function getActiveIndex() {
        var scrollLeft = track.scrollLeft;
        var amount = getScrollAmount();
        return Math.round(scrollLeft / amount);
      }

      function buildDots() {
        if (!dotsContainer) return;
        var cardWidth = cards[0].offsetWidth;
        var gap = parseFloat(getComputedStyle(track).gap) || 0;
        var visible = Math.floor(track.clientWidth / (cardWidth + gap));
        var count = Math.max(1, cards.length - visible + 1);
        dotsContainer.innerHTML = '';
        for (var i = 0; i < count; i++) {
          var dot = document.createElement('button');
          dot.className = 'vs-scroll__dot';
          dot.setAttribute('aria-label', 'Slide ' + (i + 1));
          dot.dataset.index = i;
          dotsContainer.appendChild(dot);
        }
        updateDots();
      }

      function updateDots() {
        if (!dotsContainer) return;
        var active = getActiveIndex();
        var dots = dotsContainer.querySelectorAll('.vs-scroll__dot');
        dots.forEach(function (dot, i) {
          dot.classList.toggle('vs-scroll__dot--active', i === active);
        });
      }

      if (prevBtn) {
        prevBtn.addEventListener('click', function () {
          track.scrollBy({ left: -getScrollAmount(), behavior: 'smooth' });
        });
      }
      if (nextBtn) {
        nextBtn.addEventListener('click', function () {
          track.scrollBy({ left: getScrollAmount(), behavior: 'smooth' });
        });
      }

      if (dotsContainer) {
        dotsContainer.addEventListener('click', function (e) {
          var dot = e.target.closest('.vs-scroll__dot');
          if (!dot) return;
          var index = parseInt(dot.dataset.index, 10);
          track.scrollTo({ left: index * getScrollAmount(), behavior: 'smooth' });
        });
      }

      /* Drag-to-scroll */
      var isDragging = false;
      var startX = 0;
      var scrollStart = 0;
      var dragDistance = 0;

      track.addEventListener('mousedown', function (e) {
        isDragging = true;
        startX = e.pageX;
        scrollStart = track.scrollLeft;
        dragDistance = 0;
      });

      document.addEventListener('mousemove', function (e) {
        if (!isDragging) return;
        var dx = e.pageX - startX;
        dragDistance = Math.abs(dx);
        if (dragDistance > 5 && !track.classList.contains('vs-scroll__track--dragging')) {
          track.classList.add('vs-scroll__track--dragging');
        }
        track.scrollLeft = scrollStart - dx;
      });

      document.addEventListener('mouseup', function () {
        if (!isDragging) return;
        isDragging = false;
        track.classList.remove('vs-scroll__track--dragging');
        /* Re-enable snap after drag ends */
        track.style.scrollSnapType = 'x mandatory';
        track.style.scrollBehavior = 'smooth';
        /* Snap to nearest card */
        var amount = getScrollAmount();
        var nearest = Math.round(track.scrollLeft / amount) * amount;
        track.scrollTo({ left: nearest, behavior: 'smooth' });
      });

      /* Prevent click navigation when dragging */
      track.addEventListener('click', function (e) {
        if (dragDistance > 5) {
          e.preventDefault();
          e.stopPropagation();
        }
      }, true);

      /* Touch hover: trigger hover animation on drag over cards */
      var touchHoveredCard = null;

      function setTouchHover(card) {
        if (touchHoveredCard === card) return;
        clearTouchHover();
        if (card) {
          card.classList.add('vs-scroll__card--hover');
          touchHoveredCard = card;
        }
      }

      function clearTouchHover() {
        if (touchHoveredCard) {
          touchHoveredCard.classList.remove('vs-scroll__card--hover');
          touchHoveredCard = null;
        }
      }

      track.addEventListener('touchmove', function (e) {
        var touch = e.touches[0];
        var el = document.elementFromPoint(touch.clientX, touch.clientY);
        if (!el) { clearTouchHover(); return; }
        var card = el.closest('.vs-scroll__card');
        if (card && track.contains(card)) {
          setTouchHover(card);
        } else {
          clearTouchHover();
        }
      }, { passive: true });

      track.addEventListener('touchend', function () {
        clearTouchHover();
      });

      track.addEventListener('touchcancel', function () {
        clearTouchHover();
      });

      track.addEventListener('scroll', function () {
        updateArrows();
        updateDots();
      }, { passive: true });

      updateArrows();
      buildDots();

      var resizeTimer;
      window.addEventListener('resize', function () {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(function () {
          buildDots();
          updateArrows();
        }, 150);
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vehicle-selector"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var grids = document.querySelectorAll('.vehicle-selector__grid');
    grids.forEach(function (grid) {
      var hoveredCard = null;

      function setHover(card) {
        if (hoveredCard === card) return;
        clearHover();
        if (card) {
          card.classList.add('vehicle-card--hover');
          hoveredCard = card;
        }
      }

      function clearHover() {
        if (hoveredCard) {
          hoveredCard.classList.remove('vehicle-card--hover');
          hoveredCard = null;
        }
      }

      grid.addEventListener('touchmove', function (e) {
        var touch = e.touches[0];
        var el = document.elementFromPoint(touch.clientX, touch.clientY);
        if (!el) { clearHover(); return; }
        var card = el.closest('.vehicle-card');
        if (card && grid.contains(card)) {
          setHover(card);
        } else {
          clearHover();
        }
      }, { passive: true });

      grid.addEventListener('touchend', function () {
        clearHover();
      });

      grid.addEventListener('touchcancel', function () {
        clearHover();
      });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
